import { REQUEST_CRITERIA, RECEIVE_CRITERIA, FAILURE_CRITERIA } from './constants';
import { CALL_API } from '../../middlewares/api';
import _ from 'lodash';

const shouldFetchCriteria = (state, criteriaType) => {
    const criteria = state.criteria.criteria[criteriaType];
    const fetching = state.criteria.fetching;

    if (fetching) {
        return false;
    } else if (_.isEmpty(criteria)) {
        return true;
    } else {
        return false;
    }
};

export const fetchCriteriaIfNeeded = criteriaType => {
    return {
        [CALL_API]: {
            endpoint: `/criteria?type=${criteriaType}`,
            types: [REQUEST_CRITERIA, RECEIVE_CRITERIA, FAILURE_CRITERIA],
            shouldCallAPI: state => shouldFetchCriteria(state, criteriaType),
            payload: { criteriaType }
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/criteria/actions.js